import { api } from "@/lib/api";

const toBytes = (value) => {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const raw = atob((value + padding).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

// "ok" | "ios-install" (precisa adicionar à Tela de Início) | "unsupported"
export const pushAvailability = () => {
  if (pushSupported()) return "ok";
  if (isIOS() && !isStandalone()) return "ios-install";
  return "unsupported";
};

export const registerServiceWorker = () => {
  if (!("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
};

const currentSubscription = async () => {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  return reg ? reg.pushManager.getSubscription() : null;
};

export const pushStatus = async () => {
  const sub = await currentSubscription();
  if (!sub || Notification.permission !== "granted") return { subscribed: false, notify_all: false, product_ids: [] };
  const { data } = await api.post("/push/status", { endpoint: sub.endpoint });
  return data;
};

// Precisa ser chamado direto do toque do usuário (iPhone).
export const subscribePush = async (options = {}) => {
  if (!pushSupported()) throw new Error(pushAvailability());
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("denied");
  const reg = await navigator.serviceWorker.register("/service-worker.js");
  await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await api.get("/push/public-key");
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toBytes(data.publicKey) });
  }
  const json = sub.toJSON();
  const { data } = await api.post("/push/subscribe", { endpoint: json.endpoint, keys: json.keys, ...options });
  return data;
};
